<template>
    <div class="calendar-page card card-body">
        <!-- Filter Section -->
        <div class="d-flex justify-content-between align-items-center mb-4">
            <div>
                <label>{{ $t('calendar.select_month') }}</label>
                <input type="month" v-model="selectedMonth" class="form-control" @change="loadCalendar" />
            </div>
        </div>

        <!-- Calendar Grid -->
        <div class="calendar-grid card shadow-sm">
            <!-- Calendar Days -->
            <div class="calendar-header table-responsive">
                <div
                    v-for="(day, index) in employee?.calendar"
                    :key="index"
                    class="calendar-cell text-center"
                    :class="getStatusClass(day.status)"
                    @click="showDayDetail(day)"
                >
                    <!-- Date Number at top (big) -->
                    <div class="date-number fs-4 fw-bold" :class="getDayTextColor(day.status)">
                    {{ moment(day.date).format('D') }}
                    </div>

                    <!-- Day name -->
                    <div class="day-name fw-semibold mb-1" :class="getDayTextColor(day.status)">
                    {{ $i18n.locale === 'ar' ? getDayName(day.date, 'ar') : getDayName(day.date, 'en') }}
                    </div>

                    <!-- Status Label -->
                    <!-- <div class="status-label small">
                    {{ $t('calendar.attendance.' + day.status) }}
                    </div> -->
                </div>
            </div>
        </div>

        <!-- Legend -->
        <div class="legend mt-4 d-flex flex-wrap justify-content-center">
            <div v-for="(label, key) in legend" :key="key" class="legend-item d-flex align-items-center m-2">
                <span :class="['legend-color', getStatusClass(key)]"></span>
                <span class="ms-2">{{ $t('calendar.attendance.' + key) }}</span>
            </div>
        </div>
    </div>
</template>

<script>
import moment from 'moment';
import Swal from 'sweetalert2';

export default {
    props: {
      employee_data: Object,
      activate_calendar: Object
    },
    data() {
        return {
        selectedMonth: moment().format('YYYY-MM'),
        employee: {
            calendar: [],
        },
        legend: {
            attended: '',
            absent: '',
            not_schedule: '',
            holiday: '',
            legal_leave: '',
            illegal_leave: '',
            not_employed: ''
        }
        };
    },
    methods: {
        async loadCalendar() {          
        const [year, month] = this.selectedMonth.split('-');
        const res = await this.http.post('emps/get-attendace-calendar', {
            employee_id: parseInt(this.$route.params.id),
            year: parseInt(year),
            month: parseInt(month)
        });
        if (res.status) {
            this.employee = res.emps[0];
        }
        },
        getStatusClass(status) {
        return {
            attended: 'bg-success text-white',
            absent: 'bg-danger text-white',
            not_schedule: 'bg-secondary text-white',
            holiday: 'bg-info text-white',
            legal_leave: 'bg-warning text-dark',
            illegal_leave: 'bg-dark text-white',
            not_employed: 'bg-light text-muted'
        }[status] || 'bg-light';
        },
        getDayName(date, locale) {
        return moment(date).locale(locale).format('dddd');
        },
        getDayTextColor(status) {
          const lightBackgrounds = ['not_employed', 'not_schedule', 'holiday', 'legal_leave', 'attended'];
          return lightBackgrounds.includes(status) ? 'text-dark' : 'text-white';
        },
        showDayDetail(day) {
            if (day.leave) {
                Swal.fire({
                title: day.leave.name,
                html: day.leave.descr,
                icon: 'info'
                });
            } else if (day.holiday) {
                Swal.fire({
                title: day.holiday.name,
                text: `${day.holiday.start_date} - ${day.holiday.end_date}`,
                icon: 'info'
                });
            }
        }
    },
    mounted() {
        this.loadCalendar();
        // eslint-disable-next-line vue/no-mutating-props
        this.activate_calendar.loadCalendar = this.loadCalendar;
    }
};
</script>

<style scoped>
.calendar-page {
  padding: 1rem;
}
.calendar-grid {
  display: flex;
  flex-direction: column;
  border: 1px solid #dee2e6;
  border-radius: 0.5rem;
  overflow: hidden;
}
.calendar-header {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  flex-wrap: wrap;
}
.bg-success {
  background-color: #198754 !important;
}
.bg-danger {
  background-color: #dc3545 !important;
}
.bg-secondary {
  background-color: #6c757d !important;
}
.bg-warning {
  background-color: #ffc107 !important;
}
.bg-info {
  background-color: #0dcaf0 !important;
}
.bg-dark {
  background-color: #212529 !important;
}
.bg-light {
  background-color: #f8f9fa !important;
}
.legend-color {
  width: 20px;
  height: 20px;
  display: inline-block;
  border-radius: 4px;
  margin-right: 5px;
  border: 1px solid #ccc;
}
.calendar-cell {
  border: 1px solid #dee2e6;
  min-height: 120px;
  padding: 0.5rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  /* justify-content: flex-start; */
  align-items: center;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.calendar-cell:hover {
  opacity: 0.9;
}

.date-number {
  font-size: 1.5rem;
  font-weight: bold;
  color: #000;
}

.day-name {
  font-size: 0.95rem;
}

.status-label {
  margin-top: auto;
  font-size: 0.8rem;
  color: #fff;
  text-shadow: 0 0 1px #00000033;
}

</style>